"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSyncGoodsLogDetail = getSyncGoodsLogDetail;
exports.getSyncGoodsLogList = getSyncGoodsLogList;
var _requestPIM = _interopRequireDefault(require("@/utils/requestPIM"));
function getSyncGoodsLogList(params) {
  return (0, _requestPIM.default)({
    url: '/xySyncGoodsLog/page',
    method: 'get',
    params: params
  });
}
function getSyncGoodsLogDetail(id) {
  return (0, _requestPIM.default)({
    url: "/xySyncGoodsLog/".concat(id),
    method: 'get'
  });
}